import { Controller, useFormContext } from "react-hook-form";
import { InvoiceArrivalDetailsFormValues } from "../../types";
import { View } from "react-native-ui-lib";
import { Label, Text, TextField } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface InvoiceNumberFormInputProps {
  showLabel?: boolean;
}

export const InvoiceNumberFormInput = ({
  showLabel = false,
}: InvoiceNumberFormInputProps) => {
  const { t } = useTranslation("invoice_arrival");
  const { control } = useFormContext<InvoiceArrivalDetailsFormValues>();

  return (
    <View>
      <Label label={t("form.invoice_number.label")} required></Label>
      <Text>{t("form.invoice_number.description")}</Text>
      <Controller
        name="invoiceNumber"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value ?? ""}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.invoice_number.placeholder")}
            filled={false}
          />
        )}
      />
    </View>
  );
};
